import React from 'react';

export function highlightBrand(text: string) {
  const token = "LAB ZER0";
  if (!text.includes(token)) return text;
  const parts = text.split(token);
  return (
    <>
      {parts.map((part, idx) => (
        <React.Fragment key={idx}>
          {part}
          {idx < parts.length - 1 && (
            <span className="logo-font">{token}</span>
          )}
        </React.Fragment>
      ))}
    </>
  );
}
